import { blocksOptionsConfig, newCollectionTemplate } from "@components/cmsBlocks/configs";
export const routesCollectionName = blocksOptionsConfig.collectionTypes.routes.value;

export const routesConfig = newCollectionTemplate({
  typeFields: {
    link: "text",
    title: "text",
    setId: null,
    setType: "",
    setTitle: "",
  },
  itemTemplate: {
    link: "",
    title: "",
    setId: null,
    setType: "",
    setTitle: "",
  },
  type: routesCollectionName,
  showAsTitle: "title", // only texts fields
  allowUseSets: true
})

// export const routesConfig1 = {
//   typeFields: {
//     link: "text",
//     title: "text",
//     setId: null,
//     setType: "",
//     setTitle: "",
//   },
//   itemTemplate: {
//     link: "",
//     title: "",
//     setId: null,
//     setType: "",
//     setTitle: "",
//   },
//   type: routesCollectionName,
//   showAsTitle: "title", // only texts fields
//   allowUseSets: true
// };

export const initBlockData = {
  title: "Promo title",
  discount: "",
  campaignCode: "",
  campaignRules:
    '<ul><li>To purchase a campaign ticket, add the indicated stops to the travel search and insert the code: <i><strong>summer2022</strong></i>. The discount is applied automatically.</li><li>Campaign offer is valid to purchase until 14th of June or until the discounted tickets last.</li><li>Campaign tickets may not be available for all departures.</li><li>Campaign tickets are non-refundable.</li><li>Campaign tickets can be exchanged for non-campaign tickets by paying the price difference between the old and the new ticket. The ticket can be changed from <a href="https://luxexpress.eu/en/manage-booking">here</a>.</li><li>Campaign tickets cannot be exchanged for any other campaign tickets.</li><li>The campaign is not valid for Relax seats in the Premium zone.</li><li>Campaign tickets are only available on Lux Express sales system – <a href="https://luxexpress.eu/en/">webpage</a> or official mobile app (available on <a href="https://apps.apple.com/ua/app/lux-express/id1516185295">App Store</a> and <a href="https://play.google.com/store/apps/details?id=com.luxexpress">Google Play</a>).</li><li>A limited number of campaign tickets are available on each departure.</li><li>Campaign tickets are not available for the travel period of 22.06-26.06.2022.</li></ul>',
  salesPeriodFrom: new Date(),
  salesPeriodTo: new Date(),
  travelPeriodFrom: new Date(),
  travelPeriodTo: new Date(),
  content1:
    "<p>Do not miss the chance to travel for just 9€ between the Baltic states. Explore summer in the Baltics, enjoy great food and events - travel cheap to Tallinn, Riga, Vilnius, Warsaw, Kaunas, Pärnu and Tartu!</p>",
  collections: {
    [routesCollectionName]: {
      ...routesConfig,
      items: [],
    },
  },
};
export const initEmptyBlockData = {
  title: "",
  discount: "",
  campaignCode: "",
  campaignRules: "",
  salesPeriodFrom: new Date(),
  salesPeriodTo: new Date(),
  travelPeriodFrom: new Date(),
  travelPeriodTo: new Date(),
  content1: "",
  collections: {
    [routesCollectionName]: {
      ...routesConfig,
      items: [],
    },
  },
};
